import request from '@/utils/request'

const home = {}

// banner
home.getBanner = params => request({
    url: `/ops/public/pics`,
    method: 'GET',
    params: params
})

// lang
home.getLanguages = params => request({
    url: `/api/api/l10n`,
    method: 'GET',
    params: params
})

// i18n
home.getI18nConfig = params => request({
    url: `/api/api/l10n/${params}?scope=2`,
    method: 'GET',
})
export default home